__webpack_require__.p = "/technology/";